<template>
  <div class="min-h-screen bg-white ">
    <!-- Hero -->
    <div class="flex flex-col items-center text-center py-30 px-6 bg-cover bg-center"
      :style="{ backgroundImage: `url(${require('@/assets/img/negocios.png')})` }">
      <!-- Overlay oscuro para legibilidad -->

      <h1 class="text-4xl text-white font-bold animate__animated animate__zoomInDown animate__slow">
        <span class="text-6xl text-yellow-400">Expande tu Negocio</span> con Virtual Shopping Club 🚀
      </h1>
      <p class="mt-8 text-lg text-white max-w-3xl animate__animated animate__zoomInLeft">
        El <span class=" text-yellow-400 font-extrabold">80%</span> de los negocios gastan en publicidad sin ver
        resultados.
        En <span class=" text-yellow-400 font-extrabold">Virtual Shopping Club</span> tu negocio llega directamente a
        compradores interesados.
      </p>
      <router-link :to="registroRoute" class="mt-6 px-8 py-4 bg-yellow-400 text-white font-bold rounded-full shadow-xl hover:bg-yellow-500
                            transition transform hover:scale-110">
        ¡Afíliate Ahora!
      </router-link>
    </div>

    <section class="bg-gradient-to-br from-gray-50 to-blue-50 py-20 px-6 md:px-20 overflow-hidden">
      <div class="max-w-6xl mx-auto text-center animate-fade-in-up">
        <h2 class="text-4xl md:text-5xl font-extrabold text-blue-700 mb-4">
          Aprovecha la iniciativa "Ciudades con Vida Digna"
        </h2>
        <p class="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-12">
          <span class="text-blue-700 font-semibold">Yatvii S de R.L.</span> empresa socialmente responsable está impulsando el comercio local con una inversión histórica de hasta
          <span class="text-blue-700 font-semibold">$1,225,000,000 MXN</span>
          para transformar
                    miles de negocios
                    con la campaña de cupones de descuentos para el fortalecimiento, tecnificacion del comercio local y
                    el empoderamiento del consumidor.<br>
          Sé parte de esta transformación.
        </p>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          <div
            class="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transform hover:-translate-y-1 transition duration-300">
            <img src="@/assets/img/zona.png" alt="publicidad" class="w-25 h-20 mx-auto ">
            <h3 class="text-xl font-bold text-gray-800 mb-2">245 Zonas</h3>
            <p class="text-gray-500">Cobertura nacional para impulsar el desarrollo regional.</p>
          </div>

          <div
            class="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transform hover:-translate-y-1 transition duration-300">
            <img src="@/assets/img/comercios.png" alt="publicidad" class="w-20 h-20 mx-auto ">
            <h3 class="text-xl font-bold text-gray-800 mb-2">500 Negocios por ciudad</h3>
            <p class="text-gray-500">Apoyo directo a comerciantes como tú.</p>
          </div>

          <div
            class="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transform hover:-translate-y-1 transition duration-300">
            <div class="text-blue-500 mb-4">
            <img src="@/assets/img/dolares.png" alt="publicidad" class="w-25 h-20 mx-auto ">
            </div>
            <h3 class="text-xl font-bold text-gray-800 mb-2">Hasta $61.8M USD</h3>
            <p class="text-gray-500">Inversión directa y real en todo mexico.</p>
          </div>
        </div>

        <div data-aos="fade-up"
            class="w-full max-w-3xl mx-auto bg-white rounded-xl flex justify-center items-center mb-16">
            <img src="@/assets/img/inversion.jpg" alt="VSC" class="w-full md:w-3/4 h-auto rounded-lg" />
        </div>

        <section class="flex items-center justify-center">
                    <div class="max-w-4xl w-full rounded-2xl">
                        <h2 class="text-3xl text-blue-700 font-bold text-center mb-6">
                            ¡Aprovecha los Patrocinios que Yatvii tiene para ti!
                        </h2>
                        <p class="text-xl text-gray-600 text-center mb-8">
                            En el inicio de la campaña de cupones en tu zona que tiene un valor <span class="font-semibold">$10,000 MXN</span>. Yatvii ofrece patrocinios especiales. 
                        </p>

                        <div class="grid md:grid-cols-2 gap-6">
                            <!-- 90% Patrocinio -->
                            <div data-aos="fade-up" class="bg-white rounded-xl p-6 text-center shadow">
                                <h3 class="text-xl font-bold text-green-700">90% Patrocinio</h3>
                                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                        class="text-green-700">$1,000</span></p>
                            </div>

                            <!-- 50% Patrocinio -->
                            <div data-aos="fade-up" class="bg-white rounded-xl p-6 text-center shadow">
                                <h3 class="text-xl font-bold text-green-700">50% Patrocinio</h3>
                                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                        class="text-green-700">$5,000</span></p>
                            </div>
                        </div>
                        <p class="text-blue-700 text-2xl md:text-2xl font-medium mb-2 mt-4 animate-fade-in delay-500">
                            ¿Qué tienen que hacer los negocios?
                        </p>
                        <ul class="text-xl text-gray-600 mb-12 animate-fade-in delay-500">
                            <li>1. Cubrir aportación (Con o Sin patrocinio)</li>
                            <li>2. Desear tener $1,000,000 en ventas o en beneficios</li>
                            <li>3. Otorgar <strong>descuentos</strong> desde el 10% a miembros del club</li>
                        </ul>
                    </div>
                </section>

        <div class="bg-white p-8 rounded-2xl shadow-lg max-w-4xl mx-auto animate-fade-in-up">
          <h3 class="text-2xl font-bold text-blue-800 mb-6">
            🚀 ¿Listo para transformar tu negocio?
          </h3>
          <ul class="text-left space-y-4 text-gray-600">
            <li class="flex items-start">
              <span class="text-blue-500 text-xl mr-2">✔</span> Patrocinamos negocios locales con ganas de crecer.
            </li>
            <li class="flex items-start">
              <span class="text-blue-500 text-xl mr-2">✔</span> Conectamos tu negocio con una comunidad que te impulsa.
            </li>
            <li class="flex items-start">
              <span class="text-blue-500 text-xl mr-2">✔</span> Ayudamos a que vendas más con herramientas prácticas y efectivas.
            </li>
          </ul>

          <div class="mt-8">
            <router-link :to="registroRoute"
              class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-md transition-all duration-300">
              Postula tu negocio ahora
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Video de YouTube -->
    <div class="mx-auto max-w-4xl px-6 lg:px-8 mt-16">
      <div class="aspect-w-16 aspect-h-9">
        <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/M4o5Zc7c3fQ"
          frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>



    <!-- Beneficios -->
    <h2 class="text-3xl font-serif font-extrabold text-center text-blue-800 mt-16">
      En Virtual Shopping Club los negocios obtienen:
    </h2>
    <div class="grid md:grid-cols-3 gap-6 px-8 mt-4 mb-12">
      <div class="p-6 bg-gray-200 rounded-lg hover:scale-105 transition-all duration-300">
        <h2 class="text-2xl font-semibold">📢 Publicidad</h2>
        <p class="mt-2">Haz que más clientes conozcan tu negocio con publicidad.</p>
      </div>
      <div class="p-6 bg-gray-200 rounded-lg hover:scale-105 transition-all duration-300">
        <h2 class="text-2xl font-semibold">🛒 Más Ventas</h2>
        <p class="mt-2">Llega a clientes dispuestos a comprar con nuestra plataforma.</p>
      </div>
      <div class="p-6 bg-gray-200 rounded-lg hover:scale-105 transition-all duration-300">
        <h2 class="text-2xl font-semibold">💰 Ingresos Extras</h2>
        <p class="mt-2">Obtén comisiones adicionales y genera ingresos recurrentes.</p>
      </div>
    </div>

    <div class="vsc bg-linear-to-r from-gray-300 via-blue-200 to-gray-300 mb-12 pt-6 pb-6">
      <h1 class="text-gray-800 text-3xl font-serif font-extrabold text-center">
        Obtén ganancias residuales de pesitos a ganancias ilimitadas con el Programa Fusión
      </h1>
    </div>

    <!-- Membresia y Programa f3 -->
    <div class=" max-w-4xl mx-auto text-center bg-orange-500 rounded-lg p-6 mt-2 bg-cover bg-center"
      :style="{ backgroundImage: `url(${require('@/assets/img/fondoAzul.png')})` }">
      <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <img src="@/assets/img/cardVSC.png" alt="Icono de publicidad" class="w-75 h-54 mx-auto mb-5">
        <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
          Únete al club y aumenta tus ventas
        </h2>
        <p class="neon-black text-white text-lg leading-relaxed mb-12">
          Como miembro del Club de Negocios, convierte tu marca en la favorita de nuestros clientes, con la
          membresia anual
          tu negocio tendrá mayores beneficios en publicidad, ventas efectivas,
          ingresos extras y acceso a <span class="font-semibold">2 tecnologias</span> como la
          campaña de cupones y ser centro de canje de puntos, las cuales te ayudarán a incrementar tus ganacias desde
          pesitos a más
          de $1,000,000 en ventas efectivas.
          Aparte, contarás con
          el apoyo de un experto en ventas y marketing. <br><br>
        </p>

        <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
          Convierte en <span class="text-cyan-500">miembro Fundador</span> del club de negocios
        </h2>
        <p class="neon-black text-white text-lg leading-relaxed mb-12">
          <span class="font-bold">🎁 Sé de los primeros 100 negociós de la zona en unirse</span><br>
          Obtén de cortesía la tecnologia F3 con la cual podrás recibir ingresos <span
            class="font-semibold text-green-500">pasivos</span> de todas las <span
            class="font-semibold text-green-500">ventas y cupones</span> aplicados en negocios
          afiliados de una zona de México. No tienes que vender nada, solo aprovechar el
          movimiento de la red de negocios. ¡Así de fácil! 💰🚀
        </p>

        <router-link :to="registroRoute" class="inline-block px-8 py-3 bg-white text-blue-700 font-bold text-lg rounded-lg
                                    shadow-lg hover:bg-green-600 hover:text-white transform hover:scale-105
                                    transition-all duration-300 mb-6">
          ¡Aprovecha esta oferta exclusiva!
        </router-link>
      </div>
    </div>

    <!-- Sección de Tecnologia -->
    <div class="py-16">
      <h2 class="text-4xl font-serif font-bold text-center text-cyan-700 mb-12 px-6">
        Obtienes acceso a <span class="text-yellow-400 font-bold">3 tecnologías
          exclusivas</span> que impulsarán tu negocio:
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6 lg:px-12">
        <div class="bg-white border border-yellow-500 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-yellow-400">🎟️ Campaña de cupones</h3>
          <p class="mt-2 text-gray-600">
            Con nuestras campañas tendrás una forma muy efectiva de atraer nuevos clientes, dar a conocer tu
            negocio y potencializar tus ventas efectivas.
          </p>
        </div>

        <div class="bg-white border border-yellow-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-yellow-400">🏆 Centro de canje de puntos</h3>
          <p class="mt-2 text-gray-600">
            Al ser tu negocio un centro de canje de puntos vas a obtener clientes fieles, tecnificación de
            tu negocio y ventaja competitiva con negocios externos.
          </p>
        </div>

        <div class="bg-white border border-yellow-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-yellow-400">🤝 Patrocinador F3</h3>
          <p class="mt-2 text-gray-600">
            Una tecnología solo para <span class="font-semibold text-cyan-800">miembros fundadores</span>
            con la cual podras recibir ingresos pasivos por las ventas y cupones aplicados en la zona de tu
            ciudad de residencia.
          </p>
        </div>
      </div>
    </div>

    <section class="py-12">
      <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-3xl font-bold text-gray-900 mb-6">🚨 ¿Tu negocio enfrenta estos desafíos?</h2>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div
            class="bg-gray-100 p-6 rounded-lg shadow-lg shadow-red-500 text-center border border-gray-100 hover:border-red-500">
            <h3 class="text-xl font-bold text-red-500">❌ ¿Gastas en publicidad sin ver resultados?</h3>
            <p class="text-gray-700 mt-2 text-justify">Pagar anuncios no garantiza ventas, y atraer nuevos clientes cada
              vez es más
              difícil.</p>
          </div>

          <div
            class="bg-gray-100 p-6 rounded-lg shadow-lg shadow-red-500  text-center border border-gray-100 hover:border-red-500 ">
            <h3 class="text-xl font-bold text-red-500">❌ ¿Tienes clientes que compran una vez y no regresan?</h3>
            <p class="text-gray-700 mt-2 text-justify">Sin un sistema efectivo de fidelización, es complicado generar
              ingresos
              constantes.</p>
          </div>

          <div
            class="bg-gray-100 p-6 rounded-lg shadow-lg shadow-red-500 text-center border border-gray-100 hover:border-red-500">
            <h3 class="text-xl font-bold text-red-500">❌ ¿Te cuesta destacar frente a la competencia?</h3>
            <p class="text-gray-700 mt-2 text-justify">Miles de negocios luchan por la atención de los clientes, y sin
              visibilidad
              digital, las ventas se reducen.</p>
          </div>

          <div
            class="bg-gray-100 p-6 rounded-lg shadow-lg shadow-red-500 text-center border border-gray-100 hover:border-red-500">
            <h3 class="text-xl font-bold text-red-500">❌ ¿Te gustaría ganar más sin aumentar tu carga de trabajo?</h3>
            <p class="text-gray-700 mt-2 text-justify">Depender solo de la venta de productos o servicios puede limitar
              tu
              crecimiento.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="py-12">
      <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-3xl font-bold text-gray-900 mb-6">💡 Con Virtual Shopping Club, tu negocio tiene una ventaja
          real:</h2>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Carga Administrativa Pesada -->
          <div
            class="bg-blue-400 p-6 rounded-lg shadow-lg shadow-blue-600 text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Publicidad sin gastar en anuncios.</h3>
            <p class="text-white mt-2 text-justify">Tu negocio se promociona sin que tengas que pagar por publicidad. Te
              conectamos
              con personas que buscan lo que ofreces.</p>
          </div>

          <!-- Falta de Personalización -->
          <div
            class="bg-blue-400 p-6 rounded-lg shadow-lg shadow-blue-600 text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Clientes que vuelven cada mes.</h3>
            <p class="text-white mt-2 text-justify">Tus clientes no solo compran una vez, sino que regresan porque
              obtienen
              beneficios al hacerlo.</p>
          </div>

          <div
            class="bg-blue-400 p-6 rounded-lg shadow-lg shadow-blue-600 text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Más visibilidad para tu negocio.</h3>
            <p class="text-white mt-2 text-justify">No dependas solo de redes sociales. Te ayudamos a llegar a más
              personas dentro de
              una comunidad de compradores activos.</p>
          </div>

          <div
            class="bg-blue-400 p-6 rounded-lg shadow-lg shadow-blue-600 text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Gana dinero extra sin hacer más trabajo.</h3>
            <p class="text-white mt-2 text-justify">Además de vender, puedes generar ingresos adicionales con nuestro
              sistema de
              recompensas.</p>
          </div>

          <div
            class="bg-blue-600 p-6 rounded-lg shadow-lg shadow-blue-600 text-center border border-blue-600 hover:border-gray-800">
            <h3 class="text-xl font-bold text-white">✅ Un experto que te asesora.</h3>
            <p class="text-white mt-2 text-justify">Tendrás el apoyo de un gestor que te ayuda con publicidad, ventas y
              a aprovechar
              todas las oportunidades de ingresos.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Preguntas Frecuentes (FAQ) -->
    <div class="bg-yellow-200 max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg mt-6 mb-12">
      <div class=" p-6 rounded-lg text-center text-white">
        <h3 class="text-gray-800 text-3xl font-bold">Preguntas Frecuentes</h3>
      </div>
      <div id="faqApp" class="mt-6">
        <div v-for="(faq, index) in faqs" :key="index" class="border-b border-gray-500 py-4">
          <button @click="toggleFAQ(index)" class="w-full text-left font-semibold text-lg flex justify-between">
            {{ faq.question }}
            <span class="text-gray-800">{{ faq.open ? "−" : "+" }}</span>
          </button>
          <p v-if="faq.open" class="mt-2 text-gray-700">{{ faq.answer }}</p>
        </div>
      </div>
    </div>

    <!-- CTA Final -->
    <div class=" bg-gray-300 vsc text-center py-12">
      <h3 class="text-3xl font-bold"> ¡No Te Quedes Fuera y Lleva Tu Negocio Al Siguiente Nivel! </h3>
      <img src="@/assets/img/vsc.png" alt="publicidad" class="w-40 h-30 mx-auto mt-4">
      <router-link :to="registroRoute" class="text-center mt-8 mb-8 inline-block px-8 py-3 bg-yellow-400 text-white font-bold rounded-lg
                            shadow-lg custom-shadow hover:bg-green-500 hover:text-white hover:shadow-xl transition-all
                            duration-300">
        Unirme Ahora
      </router-link>

      <div class="max-w-sm mx-auto bg-gray-900 text-white p-6 rounded-lg shadow-lg">
        <!-- Título del Plan -->
        <h2 class="text-xl text-green-400 font-semibold">Membresia <span class="text-white">(Anual)</span></h2>
        <p class="text-gray-400 text-sm mt-2">Para negocios en crecimiento</p>

        <!-- Precio -->
        <div class="mt-6 mb-6">
          <h3 class="text-5xl font-bold">$20,000 <span class="text-2xl text-gray-300">MXN</span>/<span
              class="text-3xl text-blue-400">anual</span></h3>
        </div>

        <!-- Botón principal -->
        <router-link to="/registro"
          class="mt-6 w-full bg-green-500 border border-white hover:bg-green-600 text-white font-bold py-3 px-20 rounded-xl transition duration-300">
          Comprar&nbsp;Ahora
        </router-link>

        <!-- Lista de beneficios -->
        <div class="mt-6">
          <h4 class="text-gray-300 mb-4">¿Qué incluye?</h4>
          <ul class="space-y-3 text-sm">
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>Publicidad de tu marca permanente
            </li>
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>$1,000,000 en Ventas efectivas</li>
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>Campaña de cupones</li>
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>Centro de canje de puntos</li>
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>Tecnificación de su negocio</li>
            <li class="flex items-center"><span class="text-green-400 mr-2">✔️</span>Asesoria de un experto</li>
          </ul>
        </div>
      </div>

    </div>

    <patrocinadores-comp :patrocinadores="patrocinadores" v-if="patrocinadores.length > 0"></patrocinadores-comp>
  </div>
</template>

<script>
import patrocinadoresComp from "@/components/campanias/patrocinadores";

export default {
  name: 'ClubNegocios2',
  data() {
    return {
      faqs: [
        { question: "¿Cómo funciona la afiliación?", answer: "Solo debes registrarte y pagar tu membresia de negocios.", open: false },
        { question: "¿Cuánto cuesta la membresía?", answer: "Es anual y tiene un costo accesible. Pregunta por nuestras promociones.", open: false },
        { question: "¿Cómo recibo mis ingresos extra?", answer: "Recibirás comisiones directas en tu cuenta dentro de la aplicación.", open: false }
      ]
    }
  },
  components: {
    patrocinadoresComp
  },
  props: {
    patrocinadores: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    registroRoute() {
      return typeof this.$route.params.codigo !== 'undefined' ? `/registro/campania/${this.$route.params.codigo}` :
        '/registro'
    }
  },
  methods: {
    toggleFAQ(index) {
      this.faqs[index].open = !this.faqs[index].open
    }
  }
}
</script>

<style scoped>
/* Estilos personalizados */
.neon-text {
  text-shadow: 0 0 90px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
  text-shadow: 0 0 10px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

/* Estilo adicional para pantallas pequeñas */
@media (max-width: 568px) {
  .vsc {
    padding: 0.5rem;
  }

  .vsc h1 {
    font-size: 1rem;
  }
}

/* apartado de patrocinio VSC */
@keyframes fade-in-up {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 1s ease-out forwards;
}
</style>